import { z } from 'zod';
import type { QueryClient } from '@tanstack/react-query';
import { brandsQuery } from '@/api/queries';
import type { ToolConfig } from './utils/create-tool';

const inputSchema = z.object({
  search: z.string().optional(),
  include_unlinked: z.boolean().optional().default(false),
});

async function execute(params: z.infer<typeof inputSchema>, queryClient: QueryClient) {
  const allBrands = await queryClient.fetchQuery(brandsQuery());

  let brands = allBrands
    .filter((b) => !b.isDeleted)
    .filter((b) => params.include_unlinked || b.brandCatalogBrandId != null);

  if (params.search) {
    const search = params.search.toLowerCase();
    brands = brands.filter((b) => b.brandName.toLowerCase().includes(search));
  }

  const result = brands
    .map((b) => ({
      brand_id: b.brandId,
      brand_name: b.brandName,
      brand_catalog_brand_id: b.brandCatalogBrandId,
      can_create_po: b.brandCatalogBrandId != null,
    }))
    .sort((a, b) => a.brand_name.localeCompare(b.brand_name));

  return { brands: result, total: result.length };
}

export const brandsTool: ToolConfig<typeof inputSchema> = {
  name: 'get_brands',
  description:
    'Returns the brand list with PO capability flag. Use this when the user asks about brands, wants to know which brands they can order from, or before drafting a PO to verify brand availability.',
  inputSchema,
  execute,
};
